module.exports = __webpack_public_path__ + "static/media/89cc27d4-e9bd-43de-ab56-cc7015e1ff7d.0d96dfef.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/89cc27d4-e9bd-43de-ab56-cc7015e1ff7d.woff2
// module id = 79
// module chunks = 0